// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"Container_buttonsContainer__j6XBj","visuallyHidden":"Container_visuallyHidden__VYaxa","a11yTitle":"Container_a11yTitle__Mbn3D"};